'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Generic bubble menu
var BubbleMenu = _react2['default'].createClass({
    displayName: 'BubbleMenu',


    propTypes: {
        'items': _react2['default'].PropTypes.array.isRequired, // Menu items
        'direction': _react2['default'].PropTypes.string, // Direction is opens to (top|bottom), defaults to 'bottom'
        'className': _react2['default'].PropTypes.string // Top class name
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'direction': 'bottom'
        };
    },

    getInitialState: function getInitialState() {
        return {
            'isTop': this.props.direction === 'top',
            'isBottom': this.props.direction === 'bottom'
        };
    },

    componentDidMount: function componentDidMount() {

        var root = $(_reactDom2['default'].findDOMNode(this));
        var container = root.parent();
        var h = root.height();
        var m = this.state.isTop ? -1 : 0;

        // Adjust the position
        root.css({
            'top': container.position().top + m * h
        });
    },

    render: function render() {
        var arrowClassNames = (0, _classnames2['default'])({
            'm-app-bubble--arrow': true,
            'is-down': this.state.isTop,
            'is-up': this.state.isBottom
        });

        var arrow = _jsx('div', {
            className: arrowClassNames
        });

        var items = [];

        for (var k in this.props.items) {
            var item = this.props.items[k];
            if (item) {
                items.push(_jsx('div', {
                    className: 'm-app-bubble--item item-' + k
                }, (this.props.key || '') + '-item-' + k, item));
            }
        }

        return _jsx('div', {
            className: 'm-app-bubble ' + (this.props.className || '')
        }, void 0, this.state.isBottom ? arrow : '', _jsx('div', {
            className: 'm-app-bubble--container'
        }, void 0, items), this.state.isTop ? arrow : '');
    }

});

module.exports = BubbleMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/bubble-menu.jsx
 ** module id = 666
 ** module chunks = 0
 **/